module.exports = __webpack_public_path__ + "img/LABS_LOGO.31734beb.png";